// extracted by mini-css-extract-plugin
module.exports = {"root":"mIndex_root__fIHVg","circle":"mIndex_circle__W362X"};